import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MateDriveService from "../../../../services/MateDriveService/MateDriveService";
import { getExtension } from "../../../../helpers/helper";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import CloudDownloadOutlinedIcon from "@material-ui/icons/CloudDownloadOutlined";
import CreateNewFolderOutlinedIcon from "@material-ui/icons/CreateNewFolderOutlined";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import { useTranslation } from "react-i18next";
import DeleteModal from "./DeleteModal";
import { alertState } from "../../../../recoil-store/recoil-state";
import { useSetRecoilState } from "recoil";

// Import Pages
import Confirm from "../../../../components/DataTable/DeleteConfirm";
import { CircularProgress } from "@material-ui/core";

/**
 * @Description MateDrive Header design
 * @Param       flowId -  autom id
 * @Param       setRender - func
 * @Param       selectItem - selected item file or folder
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function Header({ selectItem, flowId, setRender, selectFileItem, setSelectFileItem, setSelectedItems, selectedItems }) {
  const [show, setShow] = useState(false);
  const [directoryName, setDirectoryName] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [fileValue, setFileValue] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const setAlert = useSetRecoilState(alertState);

  const { t } = useTranslation();

  // create new directory
  async function handleCreateDirectory() {
    if (selectItem?.path !== undefined) {
      let newPath;
      if (!selectItem.is_dir) {
        let findCharIndex = selectItem.path.lastIndexOf("/");
        newPath = selectItem.path.substr(0, findCharIndex);
      } else {
        newPath = selectItem.path;
      }
      const resp = await MateDriveService.getFilterMateService(
        "CREATEDIRECTORY",
        newPath,
        directoryName,
        "",
        flowId
      );
      if (resp) {
        if (resp.status) setRender("createFolder");
      }
      setShow(!show);
    }
  }
  const uploadFile = async () => {
    let newPath = selectItem?.path === undefined ? "" : selectItem?.path;
    const resp = await MateDriveService.uploadFile(fileValue, newPath, flowId);
    if (resp) {
      if (resp.status) {
        setFileValue("");
        setInputValue("");
        setRender(true);

        setAlert(alert => ({ ...alert, show: true, message: t('FLOW-MESSAGES.LIBRARY.MATE-DRIVE.UPLOADED-SUCCESSFULLY'), severity: 'success' }))
      } else {
        setAlert(alert => ({ ...alert, show: true, message: resp.message ? t(resp.message) : t('GENERAL.FILE-UPLOAD-ERROR'), severity: 'error' }))
      }
    } else {
      setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
    }
  }

  // file upload  *xlx , jpeg vs..
  async function handleFileUpload() {
    let newPath = selectItem?.path === undefined ? "" : selectItem?.path;

    const fullName = fileValue.name;
    const result = await MateDriveService.checkFileExists(flowId, fullName, newPath);
    if (result) {
      if (result.status) {
        if (result.message === "FILE-EXISTS") {
          setConfirm(true);
        } else {
          uploadFile();
        }
      } else {
        setAlert(alert => ({ ...alert, show: true, message: result.message ? result.message : t('GENERAL.FILE-UPLOAD-ERROR'), severity: 'error' }))
        return;
      }
    } else {
      setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
      return;
    }
  }

  // upload file control
  const handleChange = async (event) => {
    if (event.target.files[0]?.name) {
      if (event.target.files[0].size > 52428801) {
        return setAlert(alert => ({
          ...alert,
          show: true,
          message: t("FLOW-MESSAGES.LIBRARY.EXCEL.FILE-BIGGER-THAN-ALLOWED-SIZE-50MB"),
          severity: 'error'
        }))
      }

      setFileValue(event.target.files[0]);
      const fullName = event.target.files[0].name;
      setInputValue(fullName);
    }
  };

  // delete selected item file or folder
  async function handleDelete() {
    if (
      selectItem?.name !== "Root" &&
      selectItem?.path !== null &&
      selectItem?.path !== undefined
    )
      setOpenDeleteModal(true);
    setSelectFileItem({})
  }

  // download selected item file
  async function handleDownload() {
    if (selectItem?.path !== null && selectItem?.path !== undefined) {
      let newPath = selectItem.path.replace(selectItem.name, "");
      setLoading(true)
      const resp = await MateDriveService.getFilterMateService(
        "DOWNLOADFILE",
        newPath,
        selectItem.name,
        "",
        flowId
      );
      setLoading(false)
      if (resp) {
        let bytes = new Uint8Array(resp.files[0].data);
        let ext = getExtension(selectItem.name);
        let blob = new Blob([bytes], { type: `application/${ext}` }); // change resultByte to bytes
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = selectItem.name;
        link.click();
      }
    }
  }

  return (
    <Grid
      item
      xs={12}
      spacing={2}
      style={{ borderBottom: "1px solid var(--celeste)" }}
    >
      <div className="matedrive-header" style={{ cursor: "context-menu", textTransform: "none" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Button onClick={() => selectItem && setShow(!show)}>
            <CreateNewFolderOutlinedIcon />{" "}
            {t("CONTENT.MATE-DRIVE.NEW-DIRECTORY")}
          </Button>
          <div className="mate-drive-center">
            <label htmlFor="file-upload" className="mate-drive-center">
              <CloudUploadOutlinedIcon /> {t("CONTENT.MATE-DRIVE.UPLOAD")}
            </label>
            <input
              id="file-upload"
              type="file"
              onChange={handleChange}
            // accept={options.fileType}
            />
          </div>
          <div className="mate-drive-uploaded-file-textcontainer">
            {inputValue?.length > 0 ? (
              <>
                <Button
                  variant="outlined"
                  color="primary"
                  style={{ marginLeft: 5 }}
                  onClick={() => handleFileUpload()}
                >
                  {t("CONTENT.MATE-DRIVE.UPLOAD")}
                </Button>
                <small className="mate-drive-uploaded-file-text" style={{ marginLeft: 10 }}>{inputValue}</small>
              </>
            ) : null}
          </div>
        </div>
        <div className="mate-drive-right-side-buttons-container">
          <Button
            style={{ alignItems: "right" }}
            disabled={selectItem?.name === "Root"}
            onClick={() => handleDelete()}
          >
            <DeleteOutlineOutlinedIcon /> {t("CONTENT.MATE-DRIVE.DELETE")}
          </Button>
          {loading ? <div className="mate-drive-circular-process-download"> <CircularProgress size={20} /> </div> : <Button
            style={{ alignItems: "right" }}
            disabled={(!selectFileItem || !Object.keys(selectFileItem)?.length)}
            onClick={() => handleDownload()}
          >
            <CloudDownloadOutlinedIcon /> {t("CONTENT.MATE-DRIVE.DOWNLOAD")}
          </Button>}
        </div>
      </div>
      {
        show ? (
          <div className="matedrive-header-create">
            <TextField
              id="outlined-basic"
              variant="outlined"
              value={directoryName}
              onChange={(e) => {
                if (e.target.value.length > 20) {
                  return setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("CONTENT.GENERAL.CHARACTER-LIMIT", { limit: 20 }),
                    severity: 'error'
                  }))
                }
                setDirectoryName(e.target.value)
              }}
            />
            <Button
              variant="outlined"
              color="primary"
              style={{ marginLeft: 5 }}
              onClick={() => handleCreateDirectory()}
            >
              {t("CONTENT.MATE-DRIVE.CREATE")}
            </Button>
          </div>
        ) : null
      }
      {
        openDeleteModal && (
          <DeleteModal
            setOpen={setOpenDeleteModal}
            setRender={setRender}
            selectItem={selectItem}
            selectedItems={selectedItems}
            flowId={flowId}
            setSelectedItems={setSelectedItems}
          />
        )
      }
      {
        confirm &&
        <Confirm setOpenDelete={setConfirm}
          message={t("CONTENT.FLOW.MATE-DRIVE.OVERWRITE-MESSAGE")}
          deleteFunc={() => uploadFile(fileValue)} />
      }
    </Grid >

  );
}
